/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = last race pts · R‑2 = 2 races ago pts`)
};

const es_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = pts última carrera · R‑2 = pts hace 2 carreras`)
};

const de_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = letztes Rennen Pkt. · R‑2 = vorletztes Rennen Pkt.`)
};

const nl_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = vorige race pnt. · R‑2 = 2 races geleden pnt.`)
};

const fr_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = pts dernière course · R‑2 = pts avant-dernière course`)
};

const it_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = pts ultima gara · R‑2 = pts penultima gara`)
};

const pt_br2_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = pts última corrida · R‑2 = pts de 2 corridas atrás`)
};

const pt_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = pts última corrida · R‑2 = pts há 2 corridas`)
};

const ja_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = 前レースのポイント · R‑2 = 2レース前のポイント`)
};

const zh_f1_budget_legend_r1r2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R‑1 = 上场积分 · R‑2 = 前两场积分`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_legend_r1r2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_legend_r1r2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_legend_r1r2", locale)
	if (locale === "en") return en_f1_budget_legend_r1r2(inputs)
	if (locale === "es") return es_f1_budget_legend_r1r2(inputs)
	if (locale === "de") return de_f1_budget_legend_r1r2(inputs)
	if (locale === "nl") return nl_f1_budget_legend_r1r2(inputs)
	if (locale === "fr") return fr_f1_budget_legend_r1r2(inputs)
	if (locale === "it") return it_f1_budget_legend_r1r2(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_legend_r1r2(inputs)
	if (locale === "pt") return pt_f1_budget_legend_r1r2(inputs)
	if (locale === "ja") return ja_f1_budget_legend_r1r2(inputs)
	return zh_f1_budget_legend_r1r2(inputs)
};